/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomainForm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 12c0-5.02 3.7-9.178 8.523-9.892h.002A9.84 9.84 0 0 1 12 2c4.838 0 8.873 3.436 9.8 8H8.21a12.642 12.642 0 0 0-.09 4l.185 1.022.288.978c.116.344.252.685.407 1.023v4.52C4.943 20.267 2 16.477 2 12zm2 0c0 .69.088 1.36.252 2h1.85a14.724 14.724 0 0 1 .08-4h-1.93A8.014 8.014 0 0 0 4 12zm2.627-4c.298-1.02.686-1.96 1.125-2.78A8.04 8.04 0 0 0 5.07 8zm2.978-2a12.02 12.02 0 0 0-.881 2H11V4.185c-.42.356-.917.958-1.395 1.815zM6.499 16H5.07a8.04 8.04 0 0 0 2.527 2.68A12.535 12.535 0 0 1 6.499 16zm12.43-8a8.04 8.04 0 0 0-2.718-2.803c.444.825.836 1.773 1.137 2.803zM13 8h2.251a12.132 12.132 0 0 0-.88-2c-.47-.84-.956-1.435-1.371-1.794zm10 4H11v11h12zm-10 4v-2h8v2zm4 2h4v3h-4zm-2 0v3h-2v-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDomainForm as DomainForm };
